<template>
  <div>
    <Box theme="box-primary" :title="type=== 'NEW_BUY' ? 'Phí theo lần mua mới' : 'Phí mua thường niên'">
      <div slot="content">
        <b-table    bordered outlined hover responsive :busy="loading" :fields="fields" :items="items" show-empty>
          <template #table-busy>
            <div class="text-center my-2 mt-5 mb-5">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Đang tải...</strong>
            </div>
          </template>

          <template #empty="scope">
            <h4 class="text-center text-bold mt-5 mb-5">Không có dữ liệu</h4>
          </template>

          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true">&check;</span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true">&nbsp;</span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>

          <template v-slot:cell(created_at)="data">
            <span>{{data.item.created_at | format_date_time}}</span>
          </template>
          <template v-slot:cell(product)="data">
            {{data.item.product.name}}
          </template>
          <template v-slot:cell(paid_payment_amount)="data">
            <span v-if="!data.item.editMode">{{data.item.paid_payment_amount | format_currency}}</span>
            <currency-input v-else v-model.number="data.item.paid_payment_amount" @change="calculatePrice($event, data.item, 'paid_payment_amount')" disabled/>
          </template>
          <template v-slot:cell(remaining_payment_amount)="data">
            <span v-if="!data.item.editMode">{{data.item.remaining_payment_amount | format_currency}}</span>
            <currency-input v-else v-model.number="data.item.remaining_payment_amount" disabled/>
          </template>
          <template v-slot:cell(total_payment_amount)="data">
            <span v-if="!data.item.editMode">{{data.item.total_payment_amount | format_currency}}</span>
            <currency-input v-else v-model.number="data.item.total_payment_amount" disabled/>
          </template>
          <template v-slot:cell(debt)="data">
            {{data.item.debt | format_currency}}
          </template>
          <template v-slot:cell(discount_value)="data">
            <span v-if="!data.item.editMode">{{data.item.discount_value | format_currency}}</span>
            <currency-input v-else v-model.number="data.item.discount_value" @change="calculatePrice($event, data.item, 'discount_value')"/>
          </template>
          <template v-slot:cell(addition_fee)="data">
            <span v-if="!data.item.editMode">{{data.item.addition_fee | format_currency}}</span>
            <currency-input v-else v-model.number="data.item.addition_fee" @change="calculatePrice($event, data.item, 'addition_fee')"/>
          </template>
          <template v-slot:cell(price)="data">
            <span v-if="!data.item.editMode">{{data.item.price | format_currency}}</span>
            <currency-input v-else v-model.number="data.item.price" @change="calculatePrice($event, data.item, 'price')" disabled/>
          </template>
          <template v-slot:cell(annual_price)="data">
            <span v-if="!data.item.editMode">{{data.item.annual_price | format_currency}}</span>
            <currency-input v-else v-model.number="data.item.annual_price" />
          </template>
          <template v-slot:cell(quantity)="data">
            <span v-if="!data.item.editMode">{{data.item.quantity}}</span>
            <input v-else type="number" class="form-control" v-model.number="data.item.quantity" @change="calculatePrice($event, data.item, 'quantity')"/>
          </template>
          <template v-slot:cell(invoice)="data">
            <span v-if="!data.item.editMode">{{data.item.invoice}}</span>
            <input v-else type="text" class="form-control" v-model="data.item.invoice"/>
          </template>
          <template v-slot:cell(payment_date)="data">
            <span v-if="!data.item.editMode">{{data.item.payment_date}}</span>
            <date-picker v-else v-model="data.item.payment_date" valueType="format" :class="payment_date_valid ? '' : 'date-picker-error' "></date-picker>
          </template>
          <template v-slot:cell(renew_date)="data">
            <span v-if="!data.item.editMode">{{data.item.renew_date}}</span>
            <date-picker v-else v-model="data.item.renew_date" valueType="format" :class="renew_date_valid ? '' : 'date-picker-error' "></date-picker>
          </template>
          <template v-slot:cell(due_date)="data">
            <span v-if="!data.item.editMode">{{data.item.due_date}}</span>
            <date-picker v-else v-model="data.item.due_date" valueType="format" :clearable="false" :class="due_date_valid ? '' : 'date-picker-error' "></date-picker>
          </template>
          <template v-slot:cell(charge_from_date)="data">
            <span v-if="!data.item.editMode">{{data.item.charge_from_date}}</span>
            <date-picker v-else v-model="data.item.charge_from_date" valueType="format" :clearable="false" :class="charge_date_valid ? '' : 'date-picker-error' "></date-picker>
          </template>
          <template v-slot:cell(charge_to_date)="data">
            <span v-if="!data.item.editMode">{{data.item.charge_to_date}}</span>
            <date-picker v-else v-model="data.item.charge_to_date" valueType="format" :clearable="false" :class="charge_date_valid ? '' : 'date-picker-error' "></date-picker>
          </template>
          <template v-slot:cell(annual_paid_payment_amount)="data">
            <span v-if="!data.item.editMode">{{data.item.annual_paid_payment_amount | format_currency}}</span>
            <currency-input v-else v-model.number="data.item.annual_paid_payment_amount" disabled/>
          </template>
          <template v-slot:cell(annual_remaining_payment_amount)="data">
            <span v-if="!data.item.editMode">{{data.item.annual_remaining_payment_amount | format_currency}}</span>
            <currency-input v-else v-model.number="data.item.annual_remaining_payment_amount" disabled/>
          </template>

          <template #head(actions)="data">
            <b-button variant="success" @click="showAddModal" class="mr-2" :disabled="orderId === null || !isEditable || disabledSave"><span class="glyphicon glyphicon-plus" aria-hidden="true" ></span>
            </b-button>
          </template>

          <template v-slot:cell(actions)="data">
            <b-button v-if="data.item.editMode" variant="warning" v-b-tooltip.hover title="Lưu" @click="save(data.item)" :disabled="!isEditable || disabledSave"><i class="fa fa-floppy-o"/></b-button>
            <b-button v-if="type=== 'ANNUAL_BUY' && !data.item.editMode" variant="success" v-b-tooltip.hover title="Thanh toán" @click="showAnnualModal(data.item)" :disabled="!isEditable || disabledSave"><i class="fa fa-money" aria-hidden="true"></i></b-button>
            <b-button v-if="!data.item.editMode" variant="warning" v-b-tooltip.hover title="Sửa" @click="edit(data.item)" :disabled="!isEditable || disabledSave"><i class="fa fa-edit"/></b-button>
            <b-button v-if="data.item.editMode" variant="danger" v-b-tooltip.hover title="Huỷ" @click="discard(data.item)" :disabled="!isEditable || disabledSave"><i class="fa fa-times"/></b-button>
            <b-button v-if="!data.item.editMode" variant="danger" v-b-tooltip.hover title="Xoá" @click="remove(data.item)" :disabled="!isEditable || disabledSave"><i class="fa fa-trash"/></b-button>
            <b-button v-if="type=== 'ANNUAL_BUY' && !data.item.editMode"
                      :variant="getAnnualOrderStatus(data.item.annual_order) === 3 ? 'danger' : 'primary'"
                      v-b-tooltip.hover :title="getAnnualOrderTooltip(data.item.annual_order)"
                      @click="stop_annual_buy(data.item)"
                      :disabled="!isEditable || disabledSave || (getAnnualOrderStatus(data.item.annual_order) !== 2)"><i
              class="fa fa-stop-circle-o"/></b-button>
          </template>
        </b-table>
      </div>

      <div slot="footer" class="d-flex align-items-center justify-content-between">
        <div class="page-size-container">
          <span>Hiển thị</span>
          <b-form-select
            id="pageSize"
            v-model="pageSize"
            :options="pageSizes"
            required
          ></b-form-select>
          <span>  dòng</span>
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRow"
          :per-page="pageSize"
          aria-controls="my-table"
        ></b-pagination>
      </div>
    </Box>
    <b-modal size='lg' :id="'listSelectProductModal' + this.type" hide-footer title="Chọn sản phẩm">
      <div class="form-group col-md-12 col-sm-12 col-xs-12">
        <ProductTable :type="type" :select-product-event="selectedProduct"></ProductTable>
      </div>
    </b-modal>
<!--    <b-modal size='sm' id="singleAnnualPaymentModal" hide-footer title="Thanh toán"-->
<!--             header-class="crm-modal">-->
<!--      <OneTimePayment :orderId="updatingOrderId" :order="order" type="ANNUAL_BUY"/>-->
<!--    </b-modal>-->
  </div>
</template>

<script>
import Box from '../../components/Box'
import OrderDetailApi from '../../api/orderDetailApi'
import Utils from '../../common/utils'
import OrderApi from '../../api/orderApi'
import DatePicker from 'vue2-datepicker'
import {mapActions, mapGetters} from 'vuex'
import {PAYMENT_METHOD_KEY, PERMISSION_KEY} from '../../common/constant'
import {isNumber} from 'lodash'
import ProductTable from '../../components/ProductTable'
import {eventBus} from '../../main'
import moment from 'moment/moment'
import AnnualPayment from './AnnualPayment'
import OneTimePayment from './OneTimePayment'

export default {
  name: 'OrderDetailList',
  components: {
    AnnualPayment,
    Box,
    DatePicker,
    ProductTable,
    OneTimePayment
  },
  props: {
    updatingOrderId: {
      type: Number,
      required: false
    },
    type: {
      type: String,
      required: true
    },
    disabledSave: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      orderId: null,
      order: null,
      company: null,
      fields: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalRow: 0,
      orderDetail: {
        order_id: this.orderId,
        type: this.type,
        company_id: null,
        product_id: null,
        product_name: null,
        quantity: 0,
        price: 0,
        discount_value: 0,
        remaining_payment_amount: 0,
        annual_paid_payment_amount: 0,
        total_payment_amount: 0,
        paid_payment_amount: 0,
        annual_remaining_payment_amount: 0,
        annual_payment_amount: 0,
        debt: 0,
        due_date: null,
        invoice: null,
        renew_date: null,
        payment_date: null,
        addition_fee: 0,
        charge_from_date: null,
        charge_to_date: null
      },
      pageSizes: [
        {text: 100, value: 100},
        {text: 50, value: 50},
        {text: 20, value: 20},
        {text: 10, value: 10}
      ],
      items: [
      ],
      modalTitle: 'Thêm mới',
      isEditable: true,
      selectedOrderDetail: null,
      due_date_valid: true,
      payment_date_valid: true,
      renew_date_valid: true,
      charge_date_valid: true,
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'editPermission'
    ]),
    errorQuantity: function () {
      return !isNumber(this.orderDetail.quantity)
    },
    errorPrice: function () {
      return !isNumber(this.orderDetail.price)
    }
  },
  mounted () {
    this.reloadOrderDetailList()
  },
  created () {
    eventBus.$on('orderCreated', (id) => {
      this.orderId = id
      this.reloadOrderDetailList()
    })
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  },
  methods: {
    ...mapActions([
      'updateInitOrderDetailId'
    ]),
    reloadOrderDetailList () {
      this.company = Utils.getCompanyByUserInfo(this.userInfo)
      if (this.updatingOrderId) {
        this.orderId = this.updatingOrderId
        this.filter()
        this.getOrderDetail()
        this.isEditable = this.hasEditPermission()
      }
      if (this.type === 'NEW_BUY') {
        this.fields = [
          {
            key: 'id',
            label: 'Mã sản phẩm',
            show: true
          },
          {
            key: 'product',
            label: 'Sản phẩm',
            show: true
          }, {
            key: 'quantity',
            label: 'Số lượng',
            show: true
          }, {
            key: 'price',
            label: 'Giá tiền',
            show: true
          }, {
            key: 'discount_value',
            label: 'Giảm giá',
            show: true
          }, {
            key: 'addition_fee',
            label: 'Thu thêm',
            show: true
          }, {
            key: 'total_payment_amount',
            label: 'Tổng tiền cần thanh toán (VNĐ)',
            show: true
          }, {
            key: 'paid_payment_amount',
            label: 'Số tiền đã thanh toán (VNĐ)',
            show: true
          }, {
            key: 'payment_date',
            label: 'Ngày thanh toán',
            show: true
          }, {
            key: 'due_date',
            label: 'Hạn thanh toán',
            show: true
          }, {
            key: 'renew_date',
            label: 'Ngày tái tục',
            show: true
          }, {
            key: 'charge_from_date',
            label: 'Ngày bắt đầu tính phí',
            show: true
          }, {
            key: 'charge_to_date',
            label: 'Ngày kết thúc tính phí',
            show: true
          }, {
            key: 'created_at',
            label: 'Thời gian tạo',
            show: true
          }, {
            key: 'actions',
            label: 'Tuỳ chọn',
            thStyle: 'width: 130px',
            class: 'actions-cell',
            show: true
          }
        ]
      } else {
        this.fields = [
          {
            key: 'id',
            label: 'Mã sản phẩm',
            show: true
          }, {
            key: 'product',
            label: 'Sản phẩm',
            show: true
          }, {
            key: 'quantity',
            label: 'Số lượng',
            show: true
          }, {
            key: 'price',
            label: 'Giá tiền (VNĐ)',
            show: true
          }, {
            key: 'discount_value',
            label: 'Giảm giá (VNĐ)',
            show: true
          }, {
            key: 'addition_fee',
            label: 'Thu thêm',
            show: true
          }, {
            key: 'annual_price',
            label: 'Số tiền cần thanh toán định kì (VNĐ)',
            show: true
          }, {
            key: 'annual_paid_payment_amount',
            label: 'Số tiền đã thanh toán (VNĐ)',
            show: true
          }, {
            key: 'annual_remaining_payment_amount',
            label: 'Số tiền còn lại (VNĐ)',
            show: true
          }, {
            key: 'debt',
            label: 'Số tiền cần thanh toán còn lại trong kỳ (VNĐ)',
            show: true
          }, {
            key: 'payment_date',
            label: 'Ngày thanh toán',
            show: true
          }, {
            key: 'due_date',
            label: 'Hạn thanh toán',
            show: true
          }, {
            key: 'charge_from_date',
            label: 'Ngày bắt đầu tính phí',
            show: true
          }, {
            key: 'charge_to_date',
            label: 'Ngày kết thúc tính phí',
            show: true
          }, {
            key: 'created_at',
            label: 'Thời gian tạo',
            show: true
          },
          {
            key: 'actions',
            label: 'Tuỳ chọn',
            thStyle: 'width: 190px',
            class: 'actions-cell',
            show: true
          }
        ]
      }
    },
    onPaymentChanged () {
      this.reloadOrderDetailList()
      this.notifyChangeOrderDetail()
    },
    errorDueDate (selectedRow) {
      return selectedRow.due_date === null || selectedRow.due_date.trim() === ''
    },
    validate () {
      return !this.errorQuantity && !this.errorPrice
    },
    isEmpty (value) {
      return (this.click && (value == null || value.length <= 0))
    },
    hasEditPermission () {
      return Utils.isAdminUser(this.userInfo) || this.editPermission.includes(PERMISSION_KEY.DATA_MANAGEMENT) || this.editPermission.includes(PERMISSION_KEY.DATA_MANAGEMENT_FOR_SALE)
    },
    buildFilterData () {
      return {order_id: this.orderId, type: this.type}
    },
    async getOrderDetail () {
      const id = this.$route.params.id
      this.loading = true
      if (id) {
        try {
          const orderDetail = (await OrderApi.get(id)).data.data
          this.orderDetail.product_id = orderDetail.product.id
          this.orderDetail.product_name = orderDetail.product.name
          this.loading = false
          this.order = orderDetail
        } catch (err) {
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        }
      }
    },
    filter () {
      if (this.loading) {
        return
      }
      this.loading = true
      OrderDetailApi.filter(this.buildFilterData(), this.currentPage - 1, this.pageSize).then(res => {
        this.loading = false
        this.items = res.data.data.records
        this.totalRow = res.data.data.total
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    },
    edit (selectedRow) {
      this.items = this.items.map(item => {
        if (item.id === selectedRow.id) {
          item.editMode = true
        }
        return item
      })
    },
    notifyChangeOrderDetail () {
      eventBus.$emit('orderDetailChanged')
    },
    save (selectedRow) {
      if (selectedRow.due_date === '' || selectedRow.due_date === null) {
        this.due_date_valid = false
        Utils.failedToast(this.$bvToast, 'Dữ liệu không hợp lệ', 'Hạn thanh toán không được để trống')
        return
      }
      if (selectedRow.payment_date === '' || selectedRow.payment_date === null) {
        this.payment_date_valid = false
        Utils.failedToast(this.$bvToast, 'Dữ liệu không hợp lệ', 'Ngày thanh toán không được để trống')
        return
      }
      if (selectedRow.charge_to_date === '' || selectedRow.charge_from_date === null) {
        this.charge_date_valid = false
        Utils.failedToast(this.$bvToast, 'Dữ liệu không hợp lệ', 'Ngày tính phí không được để trống')
        return
      }
      if (this.type === 'NEW_BUY' && (selectedRow.renew_date === '' || selectedRow.renew_date === null)) {
        this.renew_date_valid = false
        Utils.failedToast(this.$bvToast, 'Dữ liệu không hợp lệ', 'Ngày tái tục không được để trống')
        return
      }

      this.calculateOrderDetail(selectedRow)
      this.click = true
      this.saving = true
      this.loading = true
      this.orderDetail.company_id = this.company.id
      this.orderDetail.order_id = this.orderId
      this.orderDetail.product_id = selectedRow.product.id
      this.orderDetail.product_name = selectedRow.product.name
      this.orderDetail.order_id = this.orderId
      this.orderDetail.quantity = selectedRow.quantity
      this.orderDetail.price = selectedRow.price
      this.orderDetail.discount_value = selectedRow.discount_value
      this.orderDetail.remaining_payment_amount = selectedRow.remaining_payment_amount
      this.orderDetail.total_payment_amount = selectedRow.total_payment_amount
      this.orderDetail.paid_payment_amount = selectedRow.paid_payment_amount
      this.orderDetail.annual_price = selectedRow.annual_price
      this.orderDetail.debt = selectedRow.debt
      this.orderDetail.due_date = selectedRow.due_date
      this.orderDetail.invoice = selectedRow.invoice
      this.orderDetail.annual_paid_payment_amount = selectedRow.annual_paid_payment_amount
      this.orderDetail.annual_remaining_payment_amount = selectedRow.annual_remaining_payment_amount
      this.orderDetail.renew_date = selectedRow.renew_date
      this.orderDetail.payment_date = selectedRow.payment_date
      this.orderDetail.addition_fee = selectedRow.addition_fee
      this.orderDetail.charge_from_date = selectedRow.charge_from_date
      this.orderDetail.charge_to_date = selectedRow.charge_to_date

      if (selectedRow.newOrderDetail) {
        OrderDetailApi.create(this.orderDetail).then(res => {
          this.loading = false
          this.saving = false
          this.filter()
          Utils.successToast(this.$bvToast)
          this.notifyChangeOrderDetail()
        }).catch(err => {
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        })
      } else {
        this.orderDetail.order_detail_id = selectedRow.id
        OrderDetailApi.update(this.orderDetail).then(res => {
          this.loading = false
          this.saving = false
          this.filter()
          this.items = this.items.map(item => {
            item.editMode = false
            return item
          })
          Utils.successToast(this.$bvToast)
          this.notifyChangeOrderDetail()
        }).catch(err => {
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        })
      }
    },
    discard (selectedRow) {
      if (selectedRow.newOrderDetail) {
        this.items = this.items.filter(item => item.id !== selectedRow.id)
      } else {
        this.items = this.items.map(item => {
          item.editMode = false
          return item
        })
      }
    },
    remove (item) {
      if (item.id) {
        this.$bvModal.msgBoxConfirm('Xoá không thể khôi phục, bạn có chắc chắn xoá?', {
          title: false,
          buttonSize: 'sm',
          centered: true,
          size: 'sm',
          footerClass: 'p-2'
        }).then(res => {
          if (res) {
            OrderDetailApi.remove(item.id).then(res => {
              Utils.successToast(this.$bvToast)
              this.filter()
              this.$bvModal.hide('listSelectProductModal' + this.type)
              this.notifyChangeOrderDetail()
            }).catch(err => {
              Utils.handleError(this.$bvToast, err)
            })
          }
        })
      }
    },
    stop_annual_buy (item) {
      if (item.id) {
        this.$bvModal.msgBoxConfirm('Bạn có chắc dừng thu định kì không?', {
          title: false,
          buttonSize: 'sm',
          centered: true,
          size: 'sm',
          footerClass: 'p-2'
        }).then(res => {
          if (res) {
            OrderDetailApi.stop_annual_order(item.id).then(res => {
              Utils.successToast(this.$bvToast)
              this.filter()
              this.notifyChangeOrderDetail()
            }).catch(err => {
              Utils.handleError(this.$bvToast, err)
            })
          }
        })
      }
    },
    showAddModal () {
      this.$bvModal.show('listSelectProductModal' + this.type)
    },
    showAnnualModal (selectedRow) {
      this.selectedOrderDetail = selectedRow.id
      this.updateInitOrderDetailId({selectedOrderDetail: selectedRow.id})
      this.$bvModal.show('annualPaymentModal')
    },
    calculateOrderDetail (orderDetail) {
      if (this.type === 'NEW_BUY') {
        if (isNumber(orderDetail.quantity) && isNumber(orderDetail.price) && isNumber(orderDetail.discount_value) && isNumber(orderDetail.paid_payment_amount)) {
          orderDetail.remaining_payment_amount = orderDetail.quantity * orderDetail.price - orderDetail.discount_value - orderDetail.paid_payment_amount + orderDetail.addition_fee
          orderDetail.debt = orderDetail.quantity * orderDetail.price - orderDetail.discount_value - orderDetail.paid_payment_amount + orderDetail.addition_fee
          orderDetail.total_payment_amount = orderDetail.quantity * orderDetail.price - orderDetail.discount_value + orderDetail.addition_fee
        }
      } else {
        if (isNumber(orderDetail.quantity) && isNumber(orderDetail.price) && isNumber(orderDetail.discount_value)) {
          orderDetail.annual_price = orderDetail.quantity * orderDetail.price - orderDetail.discount_value + orderDetail.addition_fee
          orderDetail.annual_remaining_payment_amount = orderDetail.price * orderDetail.quantity - orderDetail.discount_value - orderDetail.annual_paid_payment_amount + orderDetail.addition_fee
          orderDetail.debt = orderDetail.quantity * orderDetail.price - orderDetail.discount_value - orderDetail.paid_payment_amount + orderDetail.addition_fee
          orderDetail.total_payment_amount = orderDetail.annual_price
        }
      }
    },
    calculatePrice ($event, selectedRow, field) {
      this.items = this.items.map(item => {
        if (item.id === selectedRow.id) {
          if (field !== 'quantity') {
            item[field] = Number($event)
          }
          this.calculateOrderDetail(item)
        }
        return item
      })
    },
    selectedProduct (product) {
      this.$bvModal.hide('listSelectProductModal' + this.type)
      const date = product.payment_method === PAYMENT_METHOD_KEY.CREDIT ? product.date_in_month_payment : moment().date()
      const due_date = date >= moment().date() ? moment().set('date', date).format('yyyy-MM-DD') : moment().set('date', date).add(1, 'month').format('yyyy-MM-DD')
      const productOrder = {
        id: this.$uuid.v1(),
        order_id: this.orderId,
        type: this.type,
        company_id: null,
        product: {
          id: product.id,
          name: product.name,
          period_fee: product.period_fee
        },
        quantity: 1,
        price: product.price,
        discount_value: 0,
        remaining_payment_amount: product.price,
        total_payment_amount: product.price,
        annual_price: product.price,
        paid_payment_amount: 0,
        annual_remaining_payment_amount: 0,
        annual_paid_payment_amount: 0,
        debt: 0,
        addition_fee: 0,
        due_date: due_date,
        payment_date: null,
        renew_date: null,
        invoice: null,
        editMode: true,
        newOrderDetail: true,
        charge_from_date: null,
        charge_to_date: null
      }
      productOrder.debt = productOrder.annual_price - productOrder.discount_value - productOrder.paid_payment_amount
      this.due_date_valid = true
      this.items.unshift(productOrder)
    },
    getAnnualOrderStatus (data) {
      if (data === null) {
        return 1
      }

      if (data.is_active) {
        return 2
      }

      return 3
    },
    getAnnualOrderTooltip (data) {
      let status = this.getAnnualOrderStatus(data)
      switch (status) {
        case 1:
          return 'Đã nhắc thu định kì'
        case 2:
          return 'Thu định kì'
        default:
          return 'Đã dừng thu định kì'
      }
    }
  },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/order_management/OrderDetailList.vue